import React, { createContext, useContext, useMemo, useState } from "react";

const QuiltFocusContext = createContext({
  pendingFocus: null,
  requestFocus: () => {},
  clearFocus: () => {},
});

export function QuiltFocusProvider({ children }) {
  const [pendingFocus, setPendingFocus] = useState(null);

  const value = useMemo(() => ({
    pendingFocus,
    requestFocus: (focus) => setPendingFocus(focus),
    clearFocus: () => setPendingFocus(null),
  }), [pendingFocus]);

  return (
    <QuiltFocusContext.Provider value={value}>
      {children}
    </QuiltFocusContext.Provider>
  );
}

export function useQuiltFocus() {
  return useContext(QuiltFocusContext);
}
